import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'
import InputText from '@/components/ui/InputText.vue'
import { message } from '@/plugins/message'


export default /*#__PURE__*/_defineComponent({
  __name: 'InputTel',
  props: {
  required: { type: Boolean, default: false },
    modelValue: { type: String, default: '' },
    label: { type: String, default: '電話番号' }
},
  emits: ["update:modelValue"],
  setup(__props, { emit }: { emit: ({
  (event: 'update:modelValue', val: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props



// eslint-disable-next-line func-call-spacing


const tel = computed({
  get: () => props.modelValue,
  set: (val: string) => (emit('update:modelValue', val))
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(InputText, _mergeProps({
    modelValue: _unref(tel),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(tel) ? (tel).value = $event : null))
  }, _ctx.$attrs, {
    pattern: "^[\\d+]{1,6}-.+$",
    "invalid-pattern-message": _unref(message)('validation.invalidTelPattern'),
    label: __props.label,
    required: __props.required
  }), null, 16, ["modelValue", "invalid-pattern-message", "label", "required"]))
}
}

})